// extracted by mini-css-extract-plugin
export default {"OptionBox":"OptionBox_OptionBox__nCTZ1","Wrapper":"OptionBox_Wrapper__xgDp+","Description":"OptionBox_Description__WJrG-"};